import React from 'react' // replace with your actual video path
import { Link } from 'react-router-dom'
import { MdArrowOutward } from 'react-icons/md'
import { homeVideo } from '../../assets/updated_assests/assets'

const Banner = () => {
    return (
        <div className="relative min-h-[700px] w-full overflow-hidden">
            {/* Background Video */}
            <video
                className="absolute top-0 left-0 w-full z-0 h-full object-cover"
                src={homeVideo}
                autoPlay
                loop
                muted
                playsInline
            />

            {/* Overlay Content */}
            <div className="relative z-0 grid md:grid-cols-5  grid-cols-1 min-h-[700px]">
                <div className=" w-full min-h-[700px] flex col-span-2 justify-center items-end p-4 md:pl-12">
                    <div>
                        <h3 className='text-white text-left font-roboto-mono font-bold italic md:text-[2.5rem] text-[1.8rem]' >
                            Your portable wardrobe for every destination
                        </h3>
                        <p className='text-white font-quicksand font-medium text-[16px] text-left'>
                            Experience the freedom of perfectly organized travel with Westbreeze’s revolutionary packing system
                        </p>
                        <div className="text-left mt-5">
                            <a href="https://www.kickstarter.com/projects/westbreeze
travel/packing-cubes-hanging-wardrobe-instantly" target="_blank" className='flex items-center gap-1 w-fit border-2 border-dark px-5 py-2 font-quicksand text-dark font-bold text-[16px] bg-white mb-5'>
                                <MdArrowOutward /> Explore & Early bird access
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner
